import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader } from "@/components/ui/sheet";
import { useTranslation } from "@/i18n/client";
import NAVBAR from "@/i18n/locales/en/navbar.json";
import { Lang } from "@/i18n/settings";
import { Menu } from "lucide-react";
import { useState } from "react";
import TitleBar from "./title-bar";
import Link from "@/components/shared/link";

type Props = {
  lang: Lang;
};

export function MobileMenu({ lang }: Readonly<Props>) {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation(lang, "navbar");

  return (
    <Sheet open={isOpen}>
      <Button
        size={"icon"}
        variant={"outline"}
        onClick={() => setIsOpen(true)}
        className={
          "my-auto flex h-[2.75rem] w-[2.75rem] items-center justify-center rounded-full border-2 border-[#F3D5A9]/30 bg-transparent text-sm leading-none sm:h-[3.75rem] sm:w-[3.75rem] sm:text-xl xl:hidden"
        }
      >
        <Menu className="h-4 w-4 sm:h-6 sm:w-6" />
      </Button>
      <SheetContent className="z-[999999999] flex min-w-full flex-col border-none portrait:gap-8">
        <SheetHeader>
          <TitleBar setIsOpen={setIsOpen} />
        </SheetHeader>
        <div className="flex w-full flex-1 flex-col items-center overflow-y-auto">
          <div className="flex w-full flex-grow flex-col">
            {(
              t("routes", {
                returnObjects: true,
              }) as (typeof NAVBAR)["routes"]
            ).map((menu) => {
              const hasSubMenus = menu.subMenus && menu.subMenus.length > 0;

              return (
                <div key={menu.href || menu.title} className="py-4">
                  <Link onClick={() => setIsOpen(false)} href={menu.href || "#"} className="block">
                    <p className="text-gold-hard text-[28px] uppercase ltr:font-playfair">
                      {menu.title}
                    </p>
                  </Link>

                  {hasSubMenus && (
                    <div className="ml-6 mt-2 flex flex-col gap-4">
                      {menu.subMenus.map((subMenu) => (
                        <Link
                          key={subMenu.href}
                          href={subMenu.href}
                          onClick={() => setIsOpen(false)}
                          className="block"
                        >
                          <p className="text-gold-light text-[22px] uppercase ltr:font-playfair">
                            {subMenu.title}
                          </p>
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
